import { render, staticRenderFns } from "./inputPhone.vue?vue&type=template&id=70c74368&"
import script from "./inputPhone.vue?vue&type=script&lang=js&"
export * from "./inputPhone.vue?vue&type=script&lang=js&"
import style0 from "./inputPhone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports